<p><b>Поиск адреса (API)</b></p>
<p class="description">
  Подсказки загружаются с эндпоинта {{ apiEndpointHint }}.
</p>
<div class="box">
  <form [formGroup]="formDefault">
    <pa-pvz-address-input
      formControlName="address"
      label="Адрес ПВЗ"
      placeholder="Начните вводить адрес"
      hint="Выберите адрес из подсказок"
    ></pa-pvz-address-input>
  </form>
</div>
@if (selectedValue; as value) {
  <div class="value-preview">
    <p><b>Выбранный адрес:</b></p>
    <pre>{{ value | json }}</pre>
  </div>
}

<p><b>Обязательное поле</b></p>
<div class="box">
  <form [formGroup]="formRequired">
    <pa-pvz-address-input
      formControlName="address"
      label="Адрес ПВЗ"
      placeholder="Начните вводить адрес"
    ></pa-pvz-address-input>
  </form>
</div>

<p><b>Адрес не выбран из подсказок</b></p>
<p class="description">
  Введите текст вручную и снимите фокус — без выбора из списка.
</p>
<div class="box">
  <form [formGroup]="formInvalid">
    <pa-pvz-address-input
      formControlName="address"
      label="Адрес ПВЗ"
      placeholder="Введите текст и уберите фокус"
    ></pa-pvz-address-input>
  </form>
</div>
